/*
 * @Author: huangbangquan
 * @Date: 2021-01-22 16:20:53
 * @LastEditTime: 2021-01-22 16:30:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qiankun-base\src\main.js
 */
import Vue from "vue";

import * as filters from "@/utils/filters";
import * as directives from "@/utils/directives";

import "./icons";
import "./core/iways-ui";
import "./core/ways-ui-vue";
import "./styles/index.scss";

import "./permission"; // permission control

import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/markPoint";

// 开发环境导入api mock数据
import { mockXHR } from "../mock";

Vue.config.productionTip = false;

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

if (process.env.NODE_ENV === "development") {
  mockXHR();
}

import { render } from "./core/render";
import { initBuryPoint } from "./utils/buryPoint";
initBuryPoint();
render();
